/** Angular Imports */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** Routing Imports */
import { Route } from '../core/route/route.service';

/** Translation Imports */
import { extract } from '../core/i18n/i18n.service';

/** Custom Components */
import { CotizacionesComponent } from './cotizaciones/cotizaciones.component';
import { CurrenciesResolver } from 'app/home/resolvers/ currencies-resolver.service';
import { LoanRepaymentComponent } from 'app/loan-transactions/loan-repayment/loan-repayment.component';
import { LoanRepaymentTemplateResolver } from 'app/home/resolvers/loanrepaymenttemplate-resolver.service';
import { ScheduleDialogComponent } from './schedule-dialog/schedule-dialog.component';
import { LoanForeclosureComponent } from 'app/loan-transactions/loan-foreclosure/loan-foreclosure.component';
import { LoanForeClosureTemplateResolver } from 'app/home/resolvers/loanforeclosuretemplate-resolver.service';
import { LoanAccountResolver } from 'app/home/resolvers/loanaccount-resolver.service';
import { LoanForeClosureQuoteResolver } from 'app/home/resolvers/loanforeclosurequote-resolver.service';


const routes: Routes = [
    Route.withShell([
      {
        path: 'cotizaciones',
        component:  CotizacionesComponent,
        data: { title: extract('Cotizaciones'), breadcrumb: 'Cotizaciones' },
      },{
        path: 'cotizaciones/abono-capital/:id',
        component:  LoanRepaymentComponent,
        data: { title: extract('Préstamos'), breadcrumb: 'Abono a Capital' },
        resolve: {  
          supportedCurrencies: CurrenciesResolver,
          loanTemplateData: LoanRepaymentTemplateResolver,       
        }
      },{
        path: 'cotizaciones/cancalecione/:id',
        component:  LoanForeclosureComponent,
        data: { title: extract('Préstamos'), breadcrumb: 'Cancelación anticipada' },
        resolve: {  
          loanAcountData: LoanAccountResolver,
          supportedCurrencies: CurrenciesResolver,
          loanRepaymentTemplateData: LoanRepaymentTemplateResolver,
          loanForeClosureData: LoanForeClosureTemplateResolver,
        }
      },{
        path: 'cotizaciones/abono-capital/:id/cotizar',
        component:  ScheduleDialogComponent,
        data: { title: extract('Préstamos'), breadcrumb: 'Cotizar' },
      },    
    ])
  ];

/**
 * Routing Module
 */
 @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
  })
export class CotizacionesRoutingModule { }
